import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

export default function availableHoursReducer(state = InitialState.availableHours, action) {
  switch (action.type) {
    case types.LOAD_AVAILABLE_HOURS_SUCCESS:
      return action.availableHours;
    case types.EDIT_AVAILABLE_HOURS_SUCCESS:
      return state.map(i => (i.id === action.availableHours.id ? action.availableHours : i));
    default:
      return state;
  }
}
